import React, { createContext, useContext, ReactNode, useMemo } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Creating the context with an empty object and default functions

export enum ToastType {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warning',
}
interface ToastContextType {
  notify: (message: string, type?: ToastType) => void;
}

const ToastContext = createContext<ToastContextType>({
  notify: () => {},
});

// ToastProvider component
export const ToastProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const notify = (message: string, type?: ToastType) => {
    
    switch (type) {
        case ToastType.SUCCESS:
            toast.success(message);
            break;
        case ToastType.ERROR:
            toast.error(message);
            break;
        case ToastType.INFO:
            toast.info(message);
            break;
        case ToastType.WARNING:
            toast.warning(message);
            break;
        default:
            toast(message);
            break;
    }
  };

  const contextValue = useMemo(() => ({ notify }), []);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <ToastContainer />
    </ToastContext.Provider>
  );
};

// Custom hook to use the toast context
export const useToast = () => useContext(ToastContext);
